import { IconComponent } from '../icon.types';

export const FlashIcon: IconComponent = (props) => (
  <svg
    width="17"
    height="24"
    viewBox="0 0 17 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.56617 24H4.71917L6.71917 16H2.58617C2.18674 15.9998 1.79289 15.9062 1.43609 15.7267C1.07929 15.5472 0.769431 15.2867 0.531271 14.966C0.293112 14.6454 0.133256 14.2734 0.0644787 13.88C-0.00429889 13.4865 0.0199084 13.0824 0.135166 12.7L3.97617 0H13.4432L10.4432 8H14.4662C14.9239 8.00029 15.373 8.1246 15.7657 8.35972C16.1584 8.59484 16.4801 8.93197 16.6965 9.33529C16.9129 9.73861 17.016 10.193 16.9948 10.6503C16.9737 11.1075 16.829 11.5504 16.5762 11.932L8.56617 24Z"
      fill="currentColor"
    />
  </svg>
);
